(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["v12-finance-calculator"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('v12-finance-calculator')) return;

    const SCRIPT_ATTR = 'data-v12-calculator-script';
    const loadPromises = new Map();

    function loadCalculatorScript(retailerId, retailerGuid) {
      const src = `https://apply.v12finance.com/JavascriptGateway/JSCalc/CalculatorScript?retailerId=${encodeURIComponent(retailerId)}&retailerGuid=${encodeURIComponent(retailerGuid)}`;
      if (loadPromises.has(src)) return loadPromises.get(src);

      const existing = document.querySelector(`script[${SCRIPT_ATTR}="${CSS.escape(src)}"]`);
      const promise = new Promise((resolve, reject) => {
        if (window.V12?.getFinanceProducts) {
          resolve(window.V12);
          return;
        }

        const script = existing || document.createElement('script');
        const onLoad = () => {
          if (window.V12?.getFinanceProducts) resolve(window.V12);
          else reject(new Error('V12 calculator failed to initialise'));
        };
        const onError = () => reject(new Error('V12 calculator script failed to load'));

        script.addEventListener('load', onLoad, { once: true });
        script.addEventListener('error', onError, { once: true });

        if (!existing) {
          script.src = src;
          script.async = true;
          script.setAttribute(SCRIPT_ATTR, src);
          document.head.appendChild(script);
        } else if (window.V12?.getFinanceProducts) {
          resolve(window.V12);
        }
      });

      loadPromises.set(src, promise);
      return promise;
    }

    function depositAmount(cashPrice, depositFactor) {
      const deposit = parseInt(Math.ceil(cashPrice * depositFactor), 10) / 100;
      return parseFloat(deposit.toFixed(2));
    }

    class V12FinanceCalculator extends HTMLElement {
      connectedCallback() {
        if (this._initialised) return;
        this._initialised = true;

        this.cashPriceInput = this.querySelector('[data-v12-cash-price]');
        this.cashRange = this.querySelector('[data-v12-cash-range]');
        this.depositInput = this.querySelector('[data-v12-deposit]');
        this.depositRange = this.querySelector('[data-v12-deposit-range]');
        this.productsList = this.querySelector('[data-v12-products]');
        this.lowestButton = this.querySelector('[data-v12-lowest]');

        this.values = {
          cashPrice: this.querySelector('[data-v12-val-cash-price]'),
          deposit: this.querySelector('[data-v12-val-deposit]'),
          amountCredit: this.querySelector('[data-v12-val-amount-credit]'),
          term: this.querySelector('[data-v12-val-term]'),
          monthly: this.querySelector('[data-v12-val-monthly]'),
          finalPayment: this.querySelector('[data-v12-val-final-payment]'),
          apr: this.querySelector('[data-v12-val-apr]'),
          annualRate: this.querySelector('[data-v12-val-annual-rate]'),
          arrangementFee: this.querySelector('[data-v12-val-arrangement-fee]'),
          settlementFee: this.querySelector('[data-v12-val-settlement-fee]'),
          totalRepayable: this.querySelector('[data-v12-val-total-repayable]'),
        };

        this.rows = {
          finalPayment: this.querySelector('[data-v12-row-final-payment]'),
          arrangementFee: this.querySelector('[data-v12-row-arrangement-fee]'),
          settlementFee: this.querySelector('[data-v12-row-settlement-fee]'),
        };

        this.bnplNote = this.querySelector('[data-v12-lbl-bnpl]');

        this.updateRangeFills();

        const retailerId = this.dataset.retailerId;
        const retailerGuid = this.dataset.retailerGuid;

        loadCalculatorScript(retailerId, retailerGuid)
          .then(() => this.initCalculator())
          .catch((error) => {
            console.error(error);
            this.labels.cashPrice.textContent = 'Finance calculator unavailable.';
          });
      }

      initCalculator() {
        this.populateProducts();
        this.updateRangeFills();
        this.calculateRepayments();

        this.productsList.addEventListener('change', () => this.calculateRepayments());
        this.cashRange.addEventListener('input', () => this.syncFromRanges());
        this.depositRange.addEventListener('input', () => this.syncFromRanges());
        this.lowestButton.addEventListener('click', () => this.selectLowestMonthly());

        this.cashPriceInput.addEventListener('keyup', () => this.syncFromInputs());
        this.depositInput.addEventListener('keyup', () => this.syncFromInputs());
      }

      updateRangeFill(range) {
        if (!range) return;
        const min = Number(range.min) || 0;
        const max = Number(range.max) || 100;
        const value = Number(range.value) || 0;
        const progress = max === min ? 0 : ((value - min) / (max - min)) * 100;
        range.style.setProperty('--range-progress', `${Math.min(100, Math.max(0, progress))}%`);
      }

      updateRangeFills() {
        this.updateRangeFill(this.cashRange);
        this.updateRangeFill(this.depositRange);
      }

      populateProducts() {
        const products = window.V12.getFinanceProducts() || [];
        this.productsList.replaceChildren();

        products.forEach((product) => {
          const option = document.createElement('option');
          option.value = product.productId;
          option.textContent = product.name;
          this.productsList.appendChild(option);
        });
      }

      syncFromRanges() {
        this.cashPriceInput.value = this.cashRange.value;
        this.depositInput.value = this.depositRange.value;
        this.updateRangeFills();
        this.calculateRepayments();
      }

      syncFromInputs() {
        this.cashRange.value = this.cashPriceInput.value;
        this.depositRange.value = this.depositInput.value;
        this.updateRangeFills();
        this.calculateRepayments();
      }

      calculateRepayments() {
        const productId = this.productsList.value;
        if (!productId || !window.V12) return;

        const financeProduct = window.V12.getFinanceProduct(productId);
        const cashPrice = parseFloat(this.cashPriceInput.value) || 0;
        const depositFactor = parseFloat(this.depositInput.value) || 0;
        const deposit = depositAmount(cashPrice, depositFactor);
        const payments = window.V12.calculate(financeProduct, cashPrice, deposit);
        this.populateDescription(payments);
      }

      populateDescription(payments) {
        const money = (amount) => `£${amount}`;
        const hasFinalPayment =
          payments.initialPayments != payments.finalPayment && payments.finalPayment > 0;

        this.values.cashPrice.textContent = money(payments.cashPrice);
        this.values.deposit.textContent = money(payments.deposit);
        this.values.amountCredit.textContent = money(payments.loanAmount);
        this.values.term.textContent = `${payments.months} months`;
        this.values.monthly.textContent = money(payments.initialPayments);
        this.values.apr.textContent = `${payments.apr}%`;
        this.values.annualRate.textContent = `${payments.annualRate}% fixed`;
        this.values.totalRepayable.textContent = money(payments.amountPayable);

        this.values.finalPayment.textContent = hasFinalPayment ? money(payments.finalPayment) : '';
        this.rows.finalPayment.hidden = !hasFinalPayment;

        const hasArrangementFee = payments.documentFee > 0;
        this.values.arrangementFee.textContent = hasArrangementFee ? money(payments.documentFee) : '';
        this.rows.arrangementFee.hidden = !hasArrangementFee;

        const hasSettlementFee = payments.settlementFee > 0;
        this.values.settlementFee.textContent = hasSettlementFee ? money(payments.settlementFee) : '';
        this.rows.settlementFee.hidden = !hasSettlementFee;

        if (payments.monthsDeferred > 0 && String(payments.name || '').indexOf('Buy Now Pay Later') >= 0) {
          this.bnplNote.textContent = `Buy Now Pay Later Option: If you pay the amount of credit plus the settlement fee of £${payments.settlementFee} by the end of the non-payment period, you will pay no interest. If you have not paid the amount of credit in full before the end of the non-payment period the £${payments.settlementFee} fee will not be payable but interest (at the rate specified above) will be charged on the outstanding credit amount, from the date we told you your agreement was live.`;
          this.bnplNote.hidden = false;
        } else {
          this.bnplNote.textContent = '';
          this.bnplNote.hidden = true;
        }
      }

      selectLowestMonthly() {
        const products = window.V12.getFinanceProducts() || [];
        let lowestMonthlyPayment = 0;
        let lowestMonthlyPaymentProductId = 0;
        const cashPrice = parseFloat(this.cashPriceInput.value) || 0;
        const depositFactor = parseFloat(this.depositInput.value) || 0;
        const deposit = depositAmount(cashPrice, depositFactor);

        products.forEach((item) => {
          const product = window.V12.getFinanceProduct(item.productId);
          const payments = window.V12.calculate(product, cashPrice, deposit);
          const monthlyPayment = payments.initialPayments;

          if (parseFloat(lowestMonthlyPayment) > parseFloat(monthlyPayment) || lowestMonthlyPayment === 0) {
            lowestMonthlyPayment = payments.initialPayments;
            lowestMonthlyPaymentProductId = product.productId;
          }
        });

        if (lowestMonthlyPaymentProductId) {
          this.productsList.value = lowestMonthlyPaymentProductId;
          this.calculateRepayments();
        }
      }
    }

    customElements.define('v12-finance-calculator', V12FinanceCalculator);
  })();
  } catch(e) { console.error(e); }
})();

})();
